const TRACKER = 'tracker';
const TRACE = 'trace';
const DEBUG = 'debug';
const INFO = 'info';
const WARN = 'warn';
const ERROR = 'error';
const FATAL = 'fatal';

module.exports = {
	priority: [TRACKER, TRACE, DEBUG, INFO, WARN, ERROR, FATAL],
	TRACKER,
	TRACE,
	DEBUG,
	INFO,
	WARN,
	ERROR,
	FATAL
};
